import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import SettingsPagesContainer from "../../../../../components/settingsPagesContainer/SettingsPagesContainer";
import TextWrapper from "../../../../../components/textWrapper/TextWrapper";
import TournamentDetailsTemplateForm from "../../../../../components/tournamentDetailsTemplateForm/TournamentDetailsTemplateForm";
import { showConfirmationModal } from "../../../../../features/confirmationModal/ConfirmationModalSlice";
import styles from "./editTournamentDetailsTemplate.module.css";

const EditTournamentDetailsTemplate = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  // The template is handed over via router state from the list row. Guard the
  // direct-navigation case (no state) so the page shows a hint instead of
  // silently editing an empty template.
  const template = location.state?.template || null;

  const handleUpdate = (payload) => {
    dispatch(
      showConfirmationModal({
        message: "هل انت متاكد من التعديل على القالب ؟",
        data: { templateId: template?._id, templateData: payload },
        actionType: "updateTournamentDetailsTemplate",
      }),
    );
  };

  if (!template) {
    return (
      <div className={styles.container}>
        <div className={styles.guard}>
          <TextWrapper textStyle="textMid">
            لا يوجد قالب محدد. الرجاء اختيار قالب من القائمة للتعديل عليه.
          </TextWrapper>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <SettingsPagesContainer
        title={`التعديل على القالب : ${template?.name || ""}`}
        fullHeight
        displayContainerClassName={styles.displayContainer}
      >
        <TournamentDetailsTemplateForm
          initialTemplate={template}
          submitLabel="حفظ التعديلات"
          onSubmit={handleUpdate}
        />
      </SettingsPagesContainer>
    </div>
  );
};

export default EditTournamentDetailsTemplate;
